import {
  IBaseMigrationSterilisationMachine,
  SterilisationMachineMappingHandler,
} from '../../../mappings/sterilisation-machine';
import {
  D4WSterilisationMachine,
  ID4WSterilisationMachine,
  SterilisationMachineSourceEntity,
} from '../../source/entities/sterilisation-machines';

export class D4WSterilisationMachineMappingHandler extends SterilisationMachineMappingHandler<
  D4WSterilisationMachine,
  SterilisationMachineSourceEntity
> {
  sourceEntity = new SterilisationMachineSourceEntity();

  translateFn = (
    record: ID4WSterilisationMachine
  ): IBaseMigrationSterilisationMachine => ({
    id: record.id,
    name: record.name,
  });
}
